import { GlobalService } from '../../shared/global.service';
import { WindowRef } from '../../services/windowService/WindowRef';
import { Component, Renderer2, Inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { DOCUMENT } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { AssetsService } from '../../shared/services/assets.service';
import { Router } from '@angular/router';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';

@Component({
  selector: 'app-mainframe',
  templateUrl: './mainframe.component.html',
  styleUrls: ['./mainframe.component.scss']
})
export class MainframeComponent {

  public title = 'DemoAccesibilidad';
  public idioma = 'Español';
  public estadoMenu = false;
  public tamanoletra: number;
  public style;
  public iconDemo: string;
  private currentTheme = 'yeti';
  public tamanoletras: any = null;
  public modificacionmenu;
  public modificacioncontenido;
  public idiomas: any;
  public imageuser: string;
  public iconomenColor: string;
  public iconomenDark: string;
  public iconomenPink: string;
  public iconomenGray: string;
  public username: string;
  public hidden;

  public escogerRol: boolean;
  public menuprincipal: boolean;
  existeSesion = false;



  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  public lang = new Subject<string>();
  public lang$: Observable<string>;
  public versionFront = ConstantesService.VERSION_FRONT;
  public versionBack: string;


  constructor(
    private breakpointObserver: BreakpointObserver, private urlService: UrlService
    // tslint:disable-next-line: deprecation
    , private renderer: Renderer2, @Inject(DOCUMENT) private document, public translate: TranslateService
    , private windowService: WindowRef, private global: GlobalService, private router: Router) {

    const usuario = sessionStorage.getItem('Usuario');
    if (usuario) {
      this.existeSesion = true;
      this.consultarVersion();
      this.iconomenColor = AssetsService.URL_ICONO_DEMO_JPG;
      this.iconomenDark = AssetsService.URL_ICONO_DEMO_BLACK_PNG;
      this.iconomenPink = AssetsService.URL_ICONO_DEMO_PINK_PNG;
      this.iconomenGray = AssetsService.URL_ICONO_DEMO_GRAY_PNG;
      this.imageuser = AssetsService.URL_IMAGEN_USER_MENU;
      this.idiomas = [];
      this.translate.setDefaultLang('es');
      const idiom1 = {
        id: 'es',
        nombre: 'Español'
      };
      const idiom2 = {
        id: 'en',
        nombre: 'Ingles'
      };
      this.imageuser = AssetsService.URL_IMAGEN_USER_MENU;
      this.idiomas = [];
      this.translate.setDefaultLang('es');
      this.idiomas.push(idiom1);
      this.idiomas.push(idiom2);
      this.obtenerConfiguracion();
      this.getIdioma();
      this.hidden = {
        display: 'none'
      };
      this.escogerRol = false;
      this.menuprincipal = true;

      if (!this.global.usuario.nombre) {
        this.username = sessionStorage.getItem(ConstantesService.NOMBRE_SESSION);
        this.global.usuario.nombre = sessionStorage.getItem(ConstantesService.NOMBRE_SESSION);
      } else {
        this.username = this.global.usuario.nombre;
      }
    }
  }

  consultarVersion() {
    const serviceProvider = 'Version';
    const url = this.urlService.getUrl(
      new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
    this.global.get(url, true)
      .subscribe(data => {
        this.versionBack = data;
      });
  }

  private obtenerConfiguracion() {
    const idioma = this.global.getIdioma();
    this.translate.setDefaultLang(idioma);
    this.global.itemValue.subscribe((nextvalue: string) => {
      this.translate.use(nextvalue);
    });
  }

  private setThemeInit() {
    // RECUPERACIÓN VARIABLES sessionStorage
    this.tamanoletra = 100;
    this.style = {
      'font-size': this.tamanoletra + '% !important',
    };
    // Recupera Tema Seleccionado
    this.currentTheme = sessionStorage.getItem('theme');
    if (this.currentTheme == null) {
      this.currentTheme = 'yeti';
    }
    this.theme(this.currentTheme);

  }

  private getIdioma() {
    // Detecta el lenguaje del navegador
    const prueba = this.windowService.getnativeWindow();
    const lgNav = prueba.navigator.language || prueba.navigator.browserLanguage;

    // Extrae las dos primeros datos
    const lg = lgNav.substring(0, 2);
    // tslint:disable-next-line: triple-equals
    if (lg == 'es') {
      // detecta y abre idiona español
      this.translate.setDefaultLang('es');
      this.idioma = 'Español';
      // tslint:disable-next-line: triple-equals
    } else if (lg == 'en') {
      // detecta y abre idiona ingles
      this.translate.setDefaultLang('en');
      this.idioma = 'English';
    }
    // else {
    //   this.translate.setDefaultLang('en');
    //   this.idioma = 'English';
    // }
    this.global.setIdioma(lg);
    this.setThemeInit();
  }

  public switchLanguage(event) {
    // tslint:disable-next-line: triple-equals
    if (event == 'Español' || event == 'Spanish' || event == 'es') {
      this.translate.use('es');
      this.global.setIdioma('es');
      this.idioma = 'Español';
    } else {
      this.translate.use('en');
      this.global.setIdioma('en');
      this.idioma = 'English';
    }
  }

  public theme(type) {
    this.renderer.removeClass(this.document.body, 'theme-' + this.currentTheme);
    if (type.theme) {
      this.currentTheme = type.theme;
    } else {
      this.currentTheme = type;
    }



    if (this.currentTheme == 'yeti') {
      this.iconDemo = this.iconomenColor;
    } else if (this.currentTheme == 'dark-white') {
      this.iconDemo = this.iconomenDark;
    } else if (this.currentTheme === 'gris-blanco') {
      this.iconDemo = this.iconomenGray;
    } else if (this.currentTheme === 'rosa-fucsia') {
      this.iconDemo = this.iconomenPink;
    }
    sessionStorage.setItem('theme', this.currentTheme);
    this.renderer.addClass(document.body, 'theme-' + this.currentTheme);
  }

  // fromero
  // 04/07/2019
  // Se modifica el mètodo para ajustar el menù en escenwario reponsive
  public accionMenu() {

    const botonMenu = document.getElementById('btnAccionMenu');
    if (!botonMenu.hidden) {
      const menu = document.getElementById('contenedorMenu');
      if (menu.classList.contains('menuActive')) {
        menu.classList.remove('menuActive');
      } else {
        menu.classList.add('menuActive');
      }
    }
  }

  public aumentarletra() {
    if (this.tamanoletra < 200) {
      this.tamanoletra += 10;
    }
    this.cambiocontraste();
  }

  public disminuirletra() {
    if (this.tamanoletra > 50) {
      this.tamanoletra -= 10;
    }
    this.cambiocontraste();
  }

  public cambiocontraste() {
    this.style = {
      'font-size': this.tamanoletra + '%'
    };
  }

  public setTamanioLetra(event) {
    this.tamanoletras = event.estilo;
  }

  public abrirayuda() {
    this.hidden = {
      display: 'inline',
      transition: 'display 0.25s'
    };
  }

  public cerrarayuda() {
    this.hidden = {
      display: 'none',
      transition: 'display 0.25s'
    };
  }

  public cambiarRol() {
    this.router.navigate(['/rol']);
  }

  public cerrarSesion() {
    this.global.cerrarSesion();
    // this.router.navigate(['/rol']);
    // cambiar para entrega
    const urlLogin = sessionStorage.getItem('urlLogin') ? sessionStorage.getItem('urlLogin') : 'http://www.google.com';
    window.location.href = urlLogin;
  }

}
